const VendaProdutoEstoqueIndisponivel = ControllerBase.extend({
    name: "VendaProdutoEstoqueIndisponivel",
    framework: 'knockout',

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'Produto', prop: 'CodigoProduto' },
            { title: 'Descricao', prop: 'Descricao' }
        ],
        getData: function () {
            return ko.mapping.toJS(this.model);
        },
    }),

    ajax: function () {
        return {
            url: "/Produto/_VendaProdutoEstoqueIndisponivel",
            type: "post",
            cache: false,
            data: {
                identificadorOrcamento: this.itemOrcamento.orcamento.get('IdentificadorOrcamento'),
                identificador: this.itemOrcamento.get('Identificador')
            }
        };
    },

    excluirItens: function () {

        var itens = []; 
        itens.push(this.itemOrcamento);

        var self = this;

        global.ajax({
            url: "/Orcamento/ExcluirItens",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.itemOrcamento.orcamento.get('IdentificadorOrcamento'),
                itens: itens
            }),
            success: function (data) {

                if (self.itemExcluidoCallback) {
                    self.itemExcluidoCallback(data);
                }
            }
        });
    },

    habilitarMenuAcoesProdutoSelecionado: function () {
        var itens = this.itemOrcamento.orcamento.get("ItensOrcamento");
        var selecionados = itens ? itens.where({ selecionado: true }) : null;
        var habilitarAcoesProduto = selecionados && selecionados.length == 1;
    },

    antesBinding: function () {

        this.appendToModel({ name: 'QuantidadePedida', value: this.itemOrcamento.get('Quantidade') });
        this.appendToModel({ name: 'IdentificadorOrcamento', value: this.itemOrcamento.get('IdentificadorOrcamento') });
        this.appendToModel({ name: 'ItensOrcamento', value: null });
        this.appendToModel({ name: 'AjustarQuantidadePerdida', value: true });
        this.appendToModel({ name: 'LancarDiferencaCotacaoPerdida', value: true });
        this.appendToModel({ name: 'LancarQuantidadeCotacaoPerdida', value: false });
        this.appendToModel({ name: 'QuantidadeEstoque', value: this.itemOrcamento.get('QuantidadeEstoque') });

        if (this.itemOrcamento.get('CodigoFilialRetirada')) {
            this.appendToModel({ name: 'CodigoFilial', value: this.itemOrcamento.get('CodigoFilialRetirada') });
        }
        else {
            this.appendToModel({ name: 'CodigoFilial', value: this.itemOrcamento.orcamento.get('CodigoFilialOrcamento') });
        }

        if (this.itemOrcamento.get('QuantidadeEstoque') <= 0) {
            this.model.AjustarQuantidadePerdida(false);
            this.model.LancarDiferencaCotacaoPerdida(false);
            this.model.LancarQuantidadeCotacaoPerdida(true);
        }

        this.model.AjustarQuantidadePerdida.subscribe($.proxy(function () {
            if (!this.model.AjustarQuantidadePerdida()) {
                this.model.LancarDiferencaCotacaoPerdida(false);
                this.model.LancarQuantidadeCotacaoPerdida(true);
            }
            else {
                this.model.LancarDiferencaCotacaoPerdida(true);
                this.model.LancarQuantidadeCotacaoPerdida(false);
            }
        }, this));
    },

    aplicar: function () {

        if (!this.model.AjustarQuantidadePerdida() && !this.model.LancarDiferencaCotacaoPerdida() && !this.model.LancarQuantidadeCotacaoPerdida()) {
            this.excluirItens();
            return;
        }

        this.quantidadePerdida = this.itemOrcamento.get('Quantidade');
        this.itemOrcamento.set('QuantidadeSolicitada', this.quantidadePerdida); // FNX-1959

        if (this.model.AjustarQuantidadePerdida() == true) {
            if (this.itemOrcamento.get('ConsideraPedidosFornecedor')) {
                this.itemOrcamento.set('Quantidade', this.itemOrcamento.get('QuantidadeEstoque'));
            }
            else {
                this.itemOrcamento.set('Quantidade', this.itemOrcamento.get('QuantidadeEstoque'));
            }
            
            this.hide();
        }

        if (this.model.LancarDiferencaCotacaoPerdida()) {
            if (this.itemOrcamento.get('ConsideraPedidosFornecedor')) {
                this.quantidadePerdida = this.quantidadePerdida - this.itemOrcamento.get('QuantidadeEstoque');
            }
            else {
                this.quantidadePerdida = this.quantidadePerdida - this.itemOrcamento.get('QuantidadeEstoque');
            }
            this.registrarPerdaCotacao(this.quantidadePerdida, true);
        }
        else if (this.model.LancarQuantidadeCotacaoPerdida()) {
            this.registrarPerdaCotacao(this.quantidadePerdida, false);
        }
    },

    registrarPerdaCotacao: function (quantidadePerda, manterItem) {

        this.registrarPerdaCotacaoController = this.showView({
            region: {
                name: 'registrarPerdaCotacaoRegion',
                selector: '#registrar-perda-cotacao-region'
            },
            controller: {
                type: RegistrarPerdaCotacaoController,
                args: {
                    identificadorOrcamento: this.itemOrcamento.orcamento.get('IdentificadorOrcamento'),
                    itemOrcamento: this.itemOrcamento,
                    quantidadePerda: quantidadePerda,
                    orcamento: this.itemOrcamento.orcamento,
                    registrarPerdaCotacaoCallback: $.proxy(this.registrarPerdaCotacaoCallback, this),
                    manterItem: manterItem
                }
            }
        });
    },

    registrarPerdaCotacaoCallback: function () {
        if (!this.registrarPerdaCotacaoController) {
            return;
        }
        this.registrarPerdaCotacaoController.hide();
        this.show();
    },
})

window.VendaProdutoEstoqueIndisponivel = VendaProdutoEstoqueIndisponivel

export {
    VendaProdutoEstoqueIndisponivel
}